import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";
import { Col, Row } from "reactstrap";
import { CognitoStore } from "../../../../stores/cognito-store";
import { UpdateAccountModal } from "./UpdateAccountModal";

export interface AccountProps {}

export const Account: React.FunctionComponent<AccountProps> = () => {
  const [email, setEmail] = React.useState("");
  const modalRef = useRef<{
    showModal: () => void;
  }>();
  const openModal = (): void => {
    if (!modalRef.current) {
      return;
    }
    modalRef.current?.showModal();
  };
  React.useEffect(() => {
    CognitoStore.userSession().then((session) => {
      return setEmail(session.email);
    });
  }, []);
  return (
    <div>
      <Row className="mt-5">
        <Col xs="12">
          <h5 className="underline cta fw400">Account</h5>
        </Col>
      </Row>
      <Row>
        <Col>
          Your account email is {email}.{" "}
          <FontAwesomeIcon onClick={openModal} className="cursor-pointer" icon={faPencilAlt} />
        </Col>
      </Row>
      <UpdateAccountModal ref={modalRef} email={email} cb={(newEmail) => setEmail(newEmail)} />
    </div>
  );
};
